import NeedToImplement from "../need-to-implement"

const CustomerHighlights = () => {
  return <NeedToImplement name="CustomerHighlights" />
}

export default CustomerHighlights
